import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { ProductService } from 'src/app/core/services/product.service';
import { ActivityLogComponent } from '../../modals/activity-log/activity-log.component';

@Component({
  selector: 'app-product-item',
  templateUrl: './product-item.component.html',
  styleUrls: ['./product-item.component.css'],
})
export class ProductItemComponent implements OnInit {
  @Input() product: any;
  @Output('seeProduct') onSeeProduct = new EventEmitter();
  @Output('deleteProduct') onDeleteProduct = new EventEmitter();
  @Output('statusProduct') onStatusProduct = new EventEmitter<Object>();

  @ViewChild('dialogActivityLog')
  private dialogActivityLog: ActivityLogComponent;

  toggleDeleteProduct = false;
  toggleCancelProduct = false;
  currentUser: any;
  activeLogList = [];

  constructor(
    private authService: AuthService,
    private productService: ProductService
  ) {}

  ngOnInit(): void {
    this.authService.LoggedinUser.subscribe((user) => {
      this.currentUser = user;
    });
  }

  seeProduct(product) {
    this.onSeeProduct.emit(product);
  }

  onDeleteModal() {
    this.toggleDeleteProduct = true;
  }

  onChangeStatusModal(product, open) {
    this.onStatusProduct.emit({ product, open });
  }

  deleteProduct(product) {
    this.onDeleteProduct.emit(product);
  }

  async openModalLogActivity(product) {
    this.productService
      .getProductActivityLog(product.inventarId, product.id)
      .subscribe((res) => {
        this.activeLogList = res;
      });
    return await this.dialogActivityLog.open();
  }

  toggleDetails;
  getDetail(product) {
    this.toggleDetails = true;
 
  }
}
